module.exports = __webpack_public_path__ + "static/media/light.3f2fcb43.svg";